/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpreviewback2Inputs */

const en_ticketpreviewback2 = /** @type {(inputs: Ticketpreviewback2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back`)
};

const de_ticketpreviewback2 = /** @type {(inputs: Ticketpreviewback2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück`)
};

/**
* | output |
* | --- |
* | "Back" |
*
* @param {Ticketpreviewback2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpreviewback2 = /** @type {((inputs?: Ticketpreviewback2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpreviewback2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpreviewback2(inputs)
	return de_ticketpreviewback2(inputs)
});
export { ticketpreviewback2 as "ticketPreviewBack" }